<template>
  <div class="top-section">
   <h1>we are sorry the app {{baseApp}} is not ready yet</h1>
     
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["baseApp"]),
  data: () => ({
  })
};
</script>
